/* GOMYART — GM · Customer setups: strip arrows + photo viewer. No dependencies. */
(function () {
  if (window.__gmUgc) return; window.__gmUgc = true;
  var rtl = function (el) { return getComputedStyle(el).direction === 'rtl'; };

  function setup(root) {
    if (root.__gmUgcInit) return; root.__gmUgcInit = true;
    var track = root.querySelector('[data-gm-ugc-track]'); if (!track) return;
    var prev = root.querySelector('[data-gm-ugc-prev]'), next = root.querySelector('[data-gm-ugc-next]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-gm-ugc-open]'));
    var lb = root.querySelector('[data-gm-ugc-lb]');
    var lImg = root.querySelector('[data-gm-ugc-img]'), lLabel = root.querySelector('[data-gm-ugc-label]'), lLink = root.querySelector('[data-gm-ugc-link]');
    var cur = 0, opener = null;

    /* arrows */
    function step(dir) { var d = track.clientWidth * 0.8 * dir; track.scrollBy({ left: rtl(track) ? -d : d, behavior: 'smooth' }); }
    function sync() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2, x = Math.abs(track.scrollLeft);
      prev.disabled = x <= 2; next.disabled = x >= max;
      var none = track.scrollWidth <= track.clientWidth + 2; prev.hidden = next.hidden = none;
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync); sync(); setTimeout(sync, 600);

    /* viewer */
    function show(i) {
      cur = (i + cards.length) % cards.length; var c = cards[cur];
      lImg.src = c.dataset.full; lImg.alt = c.dataset.alt || '';
      if (c.dataset.w) { lImg.width = c.dataset.w; lImg.height = c.dataset.h; }
      lLabel.textContent = c.dataset.label || '';
      if (c.dataset.link) { lLink.href = c.dataset.link; lLink.hidden = false; } else { lLink.hidden = true; }
    }
    function open(i, from) {
      if (!lb || typeof lb.showModal !== 'function') { window.open(cards[i].dataset.full, '_blank', 'noopener'); return; }
      opener = from; show(i); lb.showModal(); document.documentElement.style.overflow = 'hidden';
    }
    function close() { if (lb && lb.open) lb.close(); }
    cards.forEach(function (c, i) { c.addEventListener('click', function () { open(i, c); }); });
    if (lb) {
      lb.addEventListener('close', function () { document.documentElement.style.overflow = ''; if (opener) opener.focus(); });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('gm-ugc__lb-in')) close(); });
      root.querySelector('[data-gm-ugc-close]').addEventListener('click', close);
      root.querySelector('[data-gm-ugc-lprev]').addEventListener('click', function () { show(cur - 1); });
      root.querySelector('[data-gm-ugc-lnext]').addEventListener('click', function () { show(cur + 1); });
      lb.addEventListener('keydown', function (e) {
        var r = rtl(lb);
        if (e.key === 'ArrowRight') show(cur + (r ? -1 : 1));
        else if (e.key === 'ArrowLeft') show(cur + (r ? 1 : -1));
      });
      var sx = null;
      lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null; if (Math.abs(dx) > 50) show(cur + ((dx < 0) !== rtl(lb) ? 1 : -1)); });
    }
  }

  function init(scope) { (scope || document).querySelectorAll('[data-gm-ugc]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
